/**************************************************
 * Nombre:       IngresoTexto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, MenuItem, TextField} from "@mui/material";
import {Brightness1} from "@mui/icons-material";
import {useEffect, useState} from "react";
import "react-datepicker/dist/react-datepicker.css";


const IngresoHoraSelect = ({
                               props,
                               nombre,
                               dato,
                               Icono = Brightness1,
                               size = 'small',
                               editable = true,
                               requerido = false
                           }) => {

    const [hora, setHora] = useState(0)
    const [minutos, setMinutos] = useState(0)


    const horas = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23]
    const minutosMap = []
    for (let i = 0; i < 60; i++) {
        minutosMap.push(i)
    }

    const cambio = (horas, minutos) => {
        let dateTime = new Date().setHours(horas, minutos)
        props.setValue(dato, dateTime)

    }

    const cambioHora = (e) => {
        cambio(e, minutos)
    }


    const cambioMinutos = (e) => {
        setMinutos(e)
        cambio(horas, e)
    }


    useEffect(() => {

        if (props.watch(dato)){
            let fecha = props.getValues(dato)
            let fechaDate = new Date(fecha)
            setMinutos(fechaDate.getMinutes())
            setHora(fechaDate.getHours())
        }


    }, [props.watch(dato)]);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            spacing={2}
        >

            <Grid container size={6} sx={{justifyContent: 'flex-start'}}>
                <TextField
                    label={'Hora'}
                    disabled={!editable}
                    select
                    required={requerido}
                    defaultValue={0}
                    id={dato}
                    size={size}
                    value={hora}
                    onChange={(e) => cambioHora(e.target.value)}
                    InputProps={{

                        disableUnderline: true,

                    }}
                >
                    {horas.map((c, i) => (
                        <MenuItem key={`c-${i}`} value={c}>
                            {c}
                        </MenuItem>
                    ))}
                </TextField>
            </Grid>

            <Grid container size={6} sx={{justifyContent: 'flex-start'}}>
                <TextField
                    label={'Minutos'}
                    disabled={!editable}
                    select
                    defaultValue={0}
                    id={dato}
                    size={size}
                    value={minutos}
                    onChange={(e) => cambioMinutos(e.target.value)}
                    InputProps={{

                        disableUnderline: true,

                    }}
                >


                    {minutosMap.map((c, i) => (
                        <MenuItem key={`cs-${i}`} value={c}>
                            {c}
                        </MenuItem>
                    ))}
                </TextField>
            </Grid>

        </Grid>
    )

}
export default IngresoHoraSelect

